import {
  RegisterResponseModel,
  RegisterUserModel,
} from './../models/register-user.model';
import { ChangePasswordModel } from './../models/change-password.model';
import { UserModel, AddUserModel } from './../models/user.model';
import { ComplexUserModel } from './../models/complex-user.model';
import { environment } from './../../../environments/environment';
import { HttpHeaders, HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';

const httpOptions = {
  headers: new HttpHeaders({
    'Content-Type': 'application/json',
  }),
};

@Injectable({
  providedIn: 'root',
})
export class UserService {
  apiUrl = '/api/v1/account';

  constructor(private http: HttpClient, private translateService: TranslateService) {
    if (environment.production || environment.test) {
      this.apiUrl = `${environment.bffUrl}${this.apiUrl}`;
    }
  }

  getAll(): Observable<ComplexUserModel> {
    return this.http.get<ComplexUserModel>(`${this.apiUrl}`);
  }

  get(id: string): Observable<UserModel> {
    const language = this.translateService.currentLang;
    return this.http.get<UserModel>(`${this.apiUrl}/${id}?language=${language}`);
  }

  add(model: AddUserModel): Observable<UserModel> {
    return this.http.post<UserModel>(`${this.apiUrl}`, model, httpOptions);
  }

  update(model: UserModel): Observable<UserModel> {
    const language = this.translateService.currentLang;
    const url = `${this.apiUrl}/${model.id}?language=${language}`;
    return this.http.put<UserModel>(url, model, httpOptions);
  }
  remove(id: string): Observable<boolean> {
    return this.http.delete<boolean>(`${this.apiUrl}/${id}`);
  }

  import(data: string): Observable<boolean> {
    return this.http.post<boolean>(`${this.apiUrl}`, data, httpOptions);
  }

  changePassword(model: ChangePasswordModel): Observable<boolean> {
    return this.http.post<boolean>(
      `${this.apiUrl}/change-password/${model.email}`,
      model,
      httpOptions
    );
  }

  register(model: RegisterUserModel): Observable<RegisterResponseModel> {
    return this.http.post<RegisterResponseModel>(
      `${this.apiUrl}/register`,
      model,
      httpOptions
    );
  }
}
